var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAtlassian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#2684ff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.997,
    y1: 0.157,
    x2: 0.399,
    y2: 0.973,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2684ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.239.254A.732.732,0,0,0,6.264.132a.683.683,0,0,0-.2.237L.076,11.516a.645.645,0,0,0,.32.893.748.748,0,0,0,.32.071H9.053a.693.693,0,0,0,.64-.368C11.493,8.651,10.4,3.389,7.239.254Z",
    transform: "translate(0 11.52)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.554.382A15.282,15.282,0,0,0,1.63,15.708l4.025,7.9A.718.718,0,0,0,6.3,24h8.347a.722.722,0,0,0,.507-.206.7.7,0,0,0,.209-.5.7.7,0,0,0-.074-.314L3.773.379a.68.68,0,0,0-1.219,0Z",
    transform: "translate(8.64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAtlassian);
export default __webpack_public_path__ + "static/media/logo-atlassian.7db5f0ddbe2cfc1d27cb6b81dc560b8f.svg";
export { ForwardRef as ReactComponent };